import { Settings } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

type Props = {
  to: string;
};

/** Nav shortcut to settings — replaces theme toggle in top bars. */
export default function NavSettingsButton({ to }: Props) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(to)}
      className="rr-nav-icon-btn"
      aria-label="Settings"
      title="Settings"
    >
      <Settings className="rr-nav-icon h-[18px] w-[18px]" aria-hidden />
    </button>
  );
}
